/**
 * Format ISO date (YYYY-MM-DD) as Italian dd/mm/yyyy.
 * Returns empty string for invalid/missing input.
 */
export function formatItalianDate(iso) {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
}
